import { httpClient } from '@/utils/http-client'
import { AxiosResponse } from 'axios'
import { AvenAdvisorOnboardingV2LiabilityDetectionInfo, AvenAdvisorOnboardingLiabilityQuizJan2026Data } from 'aven_types'

interface ResponseData<T> {
    success: boolean
    payload: T
    error: string
}

// Onboarding V2 APIs

export const pullCreditReportAndDetectLiabilities = async (): Promise<AxiosResponse<ResponseData<AvenAdvisorOnboardingV2LiabilityDetectionInfo>>> => {
    return await httpClient.post('/avenAdvisor/onboardingV2/pullCreditReportAndDetectLiabilities')
}

export const recordLiabilityQuizV2Answers = async (payload: AvenAdvisorOnboardingLiabilityQuizJan2026Data): Promise<AxiosResponse<ResponseData<null>>> => {
    return await httpClient.post('/avenAdvisor/onboardingV2/recordLiabilityQuizV2Answers', payload)
}
